<template>
  <div>
    <h1>Setup Your New Password</h1>

    <p
      v-if="formSuccess"
    >
      Your password has been saved.
      <router-link :to="{name: 'login', query: {next: '/update-profile'}}">
        Now its time to LOG IN HERE.
      </router-link>
    </p>

    <p v-else-if="tokenStatus == 'checking'">
      Loading...
    </p>

    <form
      v-else-if="tokenStatus == 'valid'"
      @submit.prevent="submitForm('start_token')"
    >
      <div
        v-if="formErrors.non_field_errors !== undefined"
        class="alert alert-danger"
        role="alert"
      >
        {{ formErrors.non_field_errors[0] }}
      </div>

      <div class="form-group">
        <label for="password1">Password</label>
        <input
          id="password1"
          v-model="formFields.password1"
          type="password"
          required
        >
        <div
          v-if="formErrors.password1 !== undefined"
          class="invalid-feedback"
        >
          {{ formErrors.password1[0] }}
        </div>
      </div>

      <div class="form-group">
        <label for="password2">Confirm password</label>
        <input
          id="password2"
          v-model="formFields.password2"
          type="password"
          required
        >
        <div
          v-if="formErrors.password2 !== undefined"
          class="invalid-feedback"
        >
          {{ formErrors.password2[0] }}
        </div>
      </div>

      <button
        type="submit"
        class="btn btn-primary"
        :disabled="formSubmitting"
      >
        <template v-if="formSubmitting">
          Saving
          <spinner />
        </template>
        <template v-else>
          Save
        </template>
      </button>
    </form>

    <div
      v-else-if="tokenStatus == 'error'"
      class="alert alert-danger"
      role="alert"
    >
      Unable to communicate with the server.
      Please check your connection and try again.
      <a
        href="javascript:void(0);"
        class="btn btn-outline-danger btn-sm"
        @click="checkEmailVerificationLink"
      >Try again</a>
    </div>

    <p
      v-else-if="tokenStatus == 'invalid'"
      class="alert alert-danger"
      role="alert"
    >
      The password link was invalid or has already been used.
    </p>
  </div>
</template>

<script>
import ResetPassword from './ResetPassword.vue';

export default {
  name: 'StartPassword',
  extends: ResetPassword,
};
</script>

<style lang="scss" scoped>
  form {
    max-width: 256px;
  }
</style>
